import { useCallback } from "react"

import { useFileDownload } from "@/hooks/useFileDownload"
import { useAuthStore } from "@/stores/authStore"
import { getApiOrigin } from "@/utils/getApiOrigin"

interface UseExportGlTransactionsReturn {
  exportTransactions: (from: string, to: string) => Promise<boolean>
  isExporting: boolean
}

export const useExportGlTransactions = (): UseExportGlTransactionsReturn => {
  const { downloadFile, isLoading } = useFileDownload()

  const exportTransactions = useCallback(
    async (from: string, to: string): Promise<boolean> => {
      const accessToken = useAuthStore.getState().tokens.accessToken
      const baseUrl = getApiOrigin().replace("/graphql", "")
      const url = `${baseUrl}/file/report/gl_transaction?from=${from}&to=${to}`

      return downloadFile(url, "gl-transactions-export.xlsx", {
        Authorization: `Bearer ${accessToken}`,
      })
    },
    [downloadFile]
  )

  return { exportTransactions, isExporting: isLoading }
}
